import { useMutation } from '@apollo/client';
import mutation from 'client/mutations/sendEmailCode';

export default function useSendEmailCode() {
  return useMutation(mutation);
}
